function hslToHex(h: number, s: number, l: number) {
  s /= 100
  l /= 100
  const a = s * Math.min(l, 1 - l)
  const f = (n: number) => {
    const k = (n + h / 30) % 12
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1)
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0")
  }
  return `#${f(0)}${f(8)}${f(4)}`
}

export function stringToColor(str: string) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  const hue = ((hash % 360) + 360) % 360
  return hslToHex(hue, 55, 45)
}

export function extractInitials(str: string) {
  const words = str.split(" ").filter(Boolean)
  const first = words[0]?.charAt(0).toUpperCase() ?? ""
  const last = words.length > 1 ? (words[words.length - 1]?.charAt(0).toUpperCase() ?? "") : ""
  return first + last
}

export function getTextColor(hex: string) {
  const r = parseInt(hex.substring(1, 3), 16)
  const g = parseInt(hex.substring(3, 5), 16)
  const b = parseInt(hex.substring(5, 7), 16)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
  return luminance > 0.55 ? "black" : "white"
}
